/**
 * Format Explore Unknown mission depth with easy (pacifier) mission count for leaderboards.
 * @param {number | null | undefined} missions
 * @param {number | null | undefined} easyCount
 * @returns {string}
 */
export function formatExploreUnknownMissionsWithEasyCount(missions, easyCount) {
  if (missions == null) {
    return '-';
  }
  const missionNum = Number(missions);
  if (!Number.isFinite(missionNum)) {
    throw new Error(`formatExploreUnknownMissionsWithEasyCount: invalid missions (${String(missions)})`);
  }
  const easyNum = Number(easyCount);
  if (!Number.isFinite(easyNum) || easyNum < 0) {
    throw new Error(
      `formatExploreUnknownMissionsWithEasyCount: invalid easyCount (${String(easyCount)})`
    );
  }
  return `${missionNum} (${easyNum})`;
}
